import { useState, useRef, useEffect } from 'react'
import { useHistory, withRouter } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../iba-components/Button'
import { Table } from '../../../iba-components/Table'
import { getColumnList } from './tableColumns'
import { getALLClientList } from '../../api/client_managementV2'
import './clientManagement.css'
import { Loading } from '../../components/Loading'

import SignUpClientModal from '../../components/SignUpClientModal/signUpClient'
import styles from './index.module.css'

const ClientManagement = () => {
    const history = useHistory()
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [list, setList] = useState([])
    const [disabledCheckboxList, setDisabledCheckboxList] = useState([])

    const clientTable = useRef()

    const [showSignUpModal, setShowSignUpModal] = useState(false)

    // fetch data from DB
    const fetchData = async () => {
        setLoading(true)
        const { clientList } = await getALLClientList()
        clientList.forEach((element) => {
            // 0 for active. 2 for terminated. 1 for emergency stopped
            if (element.emrgncystop === 1) {
                element.status = 1
            } else if (element.terminated === 1) {
                element.status = 2
            } else {
                element.status = 0
            }
        })
        setList(clientList)
        const terminatedClientList = clientList.filter(({ terminated }) => terminated === 1).map(({ id }) => id)
        setDisabledCheckboxList(terminatedClientList)
        setLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, [])

    const handleClickRow = (original) => {
        if (original.terminated === 0 || original.terminated === 1) {
            return history.push({
                pathname: `/clientManagement/${original.id}`,
                state: {
                    id: original.id,
                    company_name: original.companyname,
                    emrgncy_stop: original.emrgncystop
                }
            })
        }
    }

    const handleCancel = (e) => {
        setShowSignUpModal(false)

        if (e === 'reloadClient' && clientTable && clientTable.current) clientTable.current.fireFetchData()
    }

    return (
        <div className="common-page client-management-container">
            <div className="client-management-banner">
                <h4>{t('clientManagement.title')}</h4>
                <div className="d-flex justify-content-between align-items-end">
                    <div className="sub-title">{t('clientManagement.title')}</div>
                    <Button
                        width="94px"
                        label={t('clientManagement.signUp')}
                        onClick={() => setShowSignUpModal(true)}
                    />
                </div>
            </div>
            <div className={styles.table_area}>
                <Loading visible={loading}>
                    <div>
                        <Table
                            data={list}
                            noDataText={loading ? '' : t('common.noData')}
                            columns={getColumnList(t)}
                            handleClickRow={handleClickRow}
                            selectedId={'id'}
                            disabledCheckboxList={disabledCheckboxList}
                            sort={[
                                {
                                    id: 'contractdate',
                                    desc: true
                                }
                            ]}
                            isBottomPagination={false}
                            isDownload={false}
                        />
                    </div>
                </Loading>
            </div>
            {showSignUpModal && (
                <SignUpClientModal
                    visible={showSignUpModal}
                    title={t('clientManagement.signUp')}
                    handleCancel={handleCancel}
                    onSubmit={fetchData}
                />
            )}
        </div>
    )
}

export default withRouter(ClientManagement)
